import { BulkNodesEditFormValues } from "@features/builder/BulkNodesEditDialog/BulkNodesEditForm/BulkNodesEditForm"
import { BulkNodesEditFormNodeRowValues } from "@features/builder/BulkNodesEditDialog/BulkNodesEditForm/schema"
import { TableCell, TableCellProps } from "@mui/material"
import { useFormContext, useFormState } from "react-hook-form"

type TableFieldCellProps = {
  nodeId: string
  fieldName: keyof BulkNodesEditFormNodeRowValues
} & TableCellProps

const TableFieldCell = ({ nodeId, fieldName, ...tableCellProps }: TableFieldCellProps) => {
  const form = useFormContext<BulkNodesEditFormValues>()
  const { dirtyFields } = useFormState({
    control: form.control,
    name: `nodes.${nodeId}.${fieldName}` as const,
  })
  const isDirty = dirtyFields.nodes?.[nodeId]?.[fieldName] ?? false

  return (
    <TableCell
      {...tableCellProps}
      sx={{
        ...tableCellProps.sx,
        ...(isDirty ? { backgroundColor: "rgb(209, 226, 238)" } : {}),
      }}
    >
      {tableCellProps.children}
    </TableCell>
  )
}

export default TableFieldCell
